export class TrimValueConverter {
    toView(value) {
        return value && value.trim() != ""? value.trim(): null;
    }
}